<template>
  <v-text-field
    flat
    solo-inverted
    hide-details
    prepend-inner-icon="mdi-magnify"
    label="Search an existing list"
    :class="{ 'hidden-sm-and-down': !alwaysShow }"
    v-model="searchBarContent"
    :rules="[rules.required,rules.uuid]"
    @keyup.enter="searchList"
    />
</template>

<script>
export default {
    name: 'FindList',
    data: () => ({
      searchBarContent: null,
      rules: {
        required: value => !!value || 'Required.',
        uuid: value => {
          const pattern = /^[a-f0-9]{32}$/
          return pattern.test(value) || 'Invalid id.'
        },
      },
    }),
    props: {
        alwaysShow: Boolean
    },
    methods: {
      searchList() {
        this.$router.push("/list/" + this.searchBarContent)
      }
    }
}
</script>
